import * as React from 'react'

import { IRemoteWorkflowStatusId } from '../program.interface'

const remoteWorkflowStatusLabel: {
  [key in IRemoteWorkflowStatusId]: string
} = {
  [IRemoteWorkflowStatusId.Completed]: 'Completed',
  [IRemoteWorkflowStatusId.Cancelled]: 'Cancelled',
  [IRemoteWorkflowStatusId.Delivered]: 'Delivered',
  [IRemoteWorkflowStatusId.Pending]: 'Pending',
  [IRemoteWorkflowStatusId.InProgress]: 'In-Progress',
  [IRemoteWorkflowStatusId.Expired]: 'Expired',
}

export const getRemoteWorkflowStatusLabel = (status: IRemoteWorkflowStatusId) =>
  remoteWorkflowStatusLabel[status] ?? '–'

interface Props {
  className?: string
  status?: IRemoteWorkflowStatusId
}

export const RemoteWorkflowStatus = function ({ className, status }: Props) {
  const value = status ? getRemoteWorkflowStatusLabel(status) : '–'
  return <span className={className}>{value}</span>
}
